var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglesmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14 2.45c.84 0 1.6.3 2.2.8L10.1 1.5A5.99 5.99 0 0 0 .74 3.34L2.77 4.9a3.54 3.54 0 0 1 3.37-2.44Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.59 6c0-.39.06-.76.18-1.11L.74 3.34a6 6 0 0 0 0 5.32L2.76 7.1A3.55 3.55 0 0 1 2.6 6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14 9.55A3.54 3.54 0 0 1 2.77 7.1L.74 8.66a5.99 5.99 0 0 0 9.31 1.84L8.13 9.02c-.54.34-1.22.53-2 .53Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.87 6c0-.35-.05-.74-.13-1.1h-5.6v2.33h3.22a2.7 2.7 0 0 1-1.23 1.8l1.92 1.47A5.97 5.97 0 0 0 11.87 6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglesmall);
export default __webpack_public_path__ + "static/media/google.small.738f13e2fdf3d38c7330de6286639a92.svg";
export { ForwardRef as ReactComponent };